import { CATEGORYS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"

export const getOne = ({ commit }, id) => {

    const url = `${CATEGORYS_API}/${id}`
    commit(types.SET_SHOW_LOADING)
    commit(types.SET_HIDE_MESSAGE)

    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        const result =data?.data ?? data;
        commit(types.SET_ITEMS,result )
        commit(types.SET_SUB_CATEGORY, result.sous_categories ?? [])
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_MESSAGE,data.message ?? "Super")
    }).catch((err) => {
        commit(types.SET_IS_ERROR)

        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_MESSAGE, (err?.response?.data?.message ?? err.message ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_MESSAGE)
        commit(types.SET_HIDE_LOADING)
     
        // dispatch('adherents/show/getAdherent',resul.userId,{root:true})
       
    })
}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



